import React, { useEffect, useState } from "react";

const PageLoader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let current = 0;

    const timer = setInterval(() => {
      current += Math.random() * 8;

      if (current > 97) current = 97;

      setProgress(Math.floor(current));
    }, 100);

    return () => {
      clearInterval(timer);
      setProgress(100);
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[99999] bg-[#0f172a]">
      <div className="absolute bottom-8 right-8 text-4xl font-bold text-orange-500">
        {progress}%
      </div>
    </div>
  );
};

export default PageLoader;
